<template>
<div>
    <!-- <client-responsible-form :getClientResponsibleList="getClientResponsibleList" ref="clientResponsibleFormModal"></client-responsible-form> -->
    <!-- <b-row>
        <b-col class="col-12">
            <div style="float:right;" class="custom-search d-flex justify-content-end">
                <b-form-group>
                    <div class="d-flex align-items-center">
                        <b-button style="float:right;" size="sm" v-b-modal.clientResponsibleForm variant="outline-primary" @click="getInfo(0)">{{ $t('clientResponsible.client_responsible_add') }}</b-button>
                    </div>
                </b-form-group>
            </div>
        </b-col>
    </b-row> -->
    <!-- table -->
    <vue-good-table id="clientResponsibleTable" ref="clientResponsibleTable" :columns="columns" :rows="rows" styleClass="vgt-table condensed tableSize" :select-options="{
        enabled: false,
        selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
        selectionInfoClass: 'custom-class',
        selectionText: 'rows selected',
        clearSelectionText: 'clear',
        disableSelectInfo: true, // disable the select info panel on top
        selectAllByGroup: true, // when used in combination with a grouped table, add a checkbox in the header row to check/uncheck the entire group
      }" theme="my-theme">
        <div slot="emptystate">
            {{ $t('dataTable.data_not_found') }}
        </div>
        <!-- Row: Table Row -->
        <template slot="table-column" slot-scope="props">
            <span v-if="props.column.field === 'name'" class="text-nowrap">
                {{ $t('clientResponsible.name') }}
            </span>
            <span v-else-if="props.column.field === 'email'" class="text-nowrap">
                {{ $t('clientResponsible.responsible_email') }}
            </span>
            <span v-else-if="props.column.field === 'mailContactType'" class="text-nowrap">
                {{ $t('clientResponsible.contact_type') }}
            </span>
            <span v-else-if="props.column.field === 'responsibleField'" class="text-nowrap">
                {{ $t('clientResponsible.jurisdiction') }}
            </span>
            <span v-else-if="props.column.field === 'ownerClient'" class="text-nowrap">
                {{ $t('clientResponsible.owner_client') }}
            </span>
            <span v-else-if="props.column.field === 'unsubscribe'" class="text-nowrap">
                {{ $t('clientResponsible.responsible_receive_email') }}
            </span>
            <!-- <span v-else-if="props.column.field === 'process'" class="text-nowrap">
            {{ $t('others.process') }}
          </span> -->
        </template>
        <!-- Column: Table Column -->
        <template slot="table-row" slot-scope="props">
            <!-- Column: CheckBox -->
            <span v-if="props.column.field === 'unsubscribe'">
                <span v-if="props.row.unsubscribe == true">{{ $t('others.yes') }}</span>
                <span v-else-if="props.row.unsubscribe == false">{{ $t('others.no') }}</span>
            </span>
            <!-- Column: Process -->
            <!-- <span v-else-if="props.column.field === 'process'">
            <span>
              <b-button v-b-tooltip.html :title="$t('others.edit')" v-b-modal.modal-top variant="primary"
                class="btn-icon mb-1 ml-1" size="sm" @click="getInfo(props.row.id)">

                <feather-icon icon="EditIcon" />
              </b-button>
              <b-button v-b-tooltip.html :title="$t('others.delete')" variant="warning" class="btn-icon mb-1 ml-1"
                size="sm" @click="deleted(props.row)">
                <feather-icon icon="XIcon" />
              </b-button>
            </span>
          </span> -->
        </template>
    </vue-good-table>
</div>
</template>

<script>
export default {
    props: {
        clientId: {
            type: Number
        }
    },
    data() {
        return {
            pageLength: 10,
            dir: false,
            columns: [{
                    label: this.$t('clientResponsible.name'),
                    field: `name`,
                },
                {
                    label: this.$t('clientResponsible.responsible_email'),
                    field: `email`,
                },
                {
                    label: this.$t('clientResponsible.contact_type'),
                    field: `mailContactType`,
                },
                {
                    label: this.$t('clientResponsible.jurisdiction'),
                    field: `responsibleField`,
                },
                {
                    label: this.$t('clientResponsible.owner_client'),
                    field: `ownerClient`,
                },
                {
                    label: this.$t('clientResponsible.responsible_receive_email'),
                    field: `unsubscribe`,
                },
                //   {
                //     label: 'Process',
                //     field: 'process',
                //     width: '10em'
                //   },
            ],
            rows: [],
            searchTerm: '',
        }
    },
    mounted() {
        this.getClientResponsibleList()
    },
    methods: {
        // async deleted(data) {
        //     data = {
        //         id: data.id
        //     }
        //     const controller = {
        //         name: 'ClientResponsible'
        //     }
        //     const payload = {
        //         data: data,
        //         controller: controller
        //     }
        //     this.$DeleteConfirm().then(result => {
        //         if (result.value) {
        //             this.$store.dispatch('moduleAuth/delete', payload).then((response) => {
        //                 if (response.data.resultStatus == true) {
        //                     this.$DeleteAlert()
        //                     this.getClientResponsibleList()
        //                 } else {
        //                     this.$WarningAlert(response.data.resultMessage)
        //                     this.getClientResponsibleList()
        //                 }
        //             })
        //         }
        //     })
        // },
        // async getInfo(id) {
        //     this.$refs.clientResponsibleFormModal.showInfo(id, this.clientId)
        // },
        getClientResponsibleList() {
            this.rows = []
            const data = {
                id: this.clientId
            }
            const controller = {
                name: 'ClientResponsible',
                actionName: 'GetClientResponsibleListByClientId'
            }
            const payload = {
                data: data,
                controller: controller
            }
            this.$store.dispatch('moduleAuth/customService', payload).then((response) => {
                if (response.data.resultStatus == true) {
                    response.data.clientResponsibleList.forEach(element => {
                        this.rows.push(element)
                    })
                } else {
                    this.$WarningAlert(response.data.resultMessage)
                }
            })
        },
    },
}
</script>

<style lang="scss">
.tableSize {
    font-size: 13px !important;
    border-collapse: collapse;
    width: 100%;
    max-width: 100%;
    table-layout: auto;
}
</style>
